import * as React from 'react';
import moment from 'moment';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';

interface Props {
  children: string;
}

type Enhanced = Props & InjectedTranslateProps;

export const DateTime = translate(({ t, children }: Enhanced) => {
  const dateTime = moment(children);

  const diff = moment().diff(dateTime, 'days');

  return (
    <>
      {diff >= 365
        ? dateTime.format('D MMMM YYYY')
        : t('{{date}} at {{time}}', {
            date: dateTime.format('D MMMM'),
            time: dateTime.format('HH:mm'),
          })}
    </>
  );
});
